/*
Helper to convert object key names in analytics track object to DTM-friendly format

Converts:

track: {
	name: 'MyName',
	type: 'MyType'
}

to:

track: {
	data-track-name: 'MyName',
	data-track-type: 'MyType'
 }
 */

function fix_key(key) {
	// Test whether passed key is for base data-track attribute
	if ( key === 'track' ) {
		return 'data-track';
	} else {
		return 'data-track-' + key;
	}

}

export default (track) => {

	var trackVars = track === undefined ? null : Object.assign(
		{},
		...Object.keys(track) .
		map(key => ({[fix_key(key)]: track[key]}))
	)

	return trackVars;
}
